import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '../../../../Shared/Form/Button'
import { adminInvoicesSendUnsent } from '../../../../../api'
import Alert from '../../../../Shared/Alert'
import Loader from '../../../../Shared/Loader'

class SendUnsentInvoices extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: false
    }
  }

  componentDidMount () {
    this.mounted = true
  }

  componentWillUnmount () {
    this.mounted = false
  }

  sendUnsent = () => {
    if (this.state.loading) {
      return
    }
    this.setState({ loading: true, error: false }, () => {
      adminInvoicesSendUnsent().fetchPromise.then(() => {
      }).catch(() => {
        if (!this.mounted)
          return
        this.setState({ error: true })
      }).finally(() => {
        if (!this.mounted)
          return
        this.setState({ loading: false })
      })
    })
  }

  render () {
    const { t } = this.props
    return (
      <div style={{ position: 'relative' }}>
        {this.state.loading ? <Loader size={16}/> : null}
        {this.state.error ? <Alert type={'danger'}>{t('ERROR')}</Alert> : null}
        <Button onClick={this.sendUnsent}>{t('SEND_UNSENT_INVOICES')}</Button>
      </div>
    )
  }
}

export default withTranslation()(SendUnsentInvoices)
